function PersonAddIcon({ width = '22', height = '22' }: { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 11.25C13.5376 11.25 16 8.78757 16 5.75C16 2.71243 13.5376 0.25 10.5 0.25C7.46243 0.25 5 2.71243 5 5.75C5 8.78757 7.46243 11.25 10.5 11.25Z"
        fill="#CE181E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.931 20.7621C10.888 19.6461 10.25 18.1471 10.25 16.5001C10.25 14.8191 10.915 13.2931 11.995 12.1691C11.508 12.1321 11.008 12.1121 10.5 12.1121C7.178 12.1121 4.237 12.9431 2.411 14.1881C1.018 15.1381 0.25 16.3451 0.25 17.6121V19.0631C0.25 19.5131 0.429 19.9461 0.748 20.2651C1.067 20.5831 1.499 20.7631 1.95 20.7631L11.931 20.7621Z"
        fill="#CE181E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 11.25C13.602 11.25 11.25 13.602 11.25 16.5C11.25 19.398 13.602 21.75 16.5 21.75C19.398 21.75 21.75 19.398 21.75 16.5C21.75 13.602 19.398 11.25 16.5 11.25ZM17.25 15.75V14.75C17.25 14.336 16.914 14 16.5 14C16.086 14 15.75 14.336 15.75 14.75V15.75H14.75C14.336 15.75 14 16.086 14 16.5C14 16.914 14.336 17.25 14.75 17.25H15.75V18.25C15.75 18.664 16.086 19 16.5 19C16.914 19 17.25 18.664 17.25 18.25V17.25H18.25C18.664 17.25 19 16.914 19 16.5C19 16.086 18.664 15.75 18.25 15.75H17.25Z"
        fill="#231F20"
      />
    </svg>
  );
}

export default PersonAddIcon;
